import { combineReducers } from 'redux'
import { authentication } from '../_reducers/authentication.reducer'
import { reducer as toastrReducer } from 'react-redux-toastr'
import { loadingBarReducer } from 'react-redux-loading-bar'

export default combineReducers({
  authentication,
  toastr: toastrReducer,
  loadingBar: loadingBarReducer,
})
